"use client";
import { useEffect, useState } from "react";
import Masonry from "react-masonry-css";

const breakpointColumnsObj = {
    default: 3,
    1200: 3,
    992: 2,
    576: 1
};

export default function Gallery() {
    const [galaryImages, setGalaryImages] = useState([]);
    const [bannerImage, setBannerImage] = useState("");
    const [loading, setLoading] = useState(true);
    // const images = [
    //     { src: "assets/img/newgal-1.png" },
    //     { src: "assets/img/newgal-2.png" },
    //     { src: "assets/img/newgal-3.png" },
    //     { src: "assets/img/newgal-4.png" },
    //     { src: "assets/img/newgal-6.png" },
    //     { src: "assets/img/newgal-7.png" }
    // ];
    useEffect(() => {
        const fetchGalaryImages = async () => {
            try {
                const response = await fetch("/api/web-content");

                if (response.ok) {
                    const data = await response.json();
                    setGalaryImages(data.gallery?.images || []);
                    setBannerImage(data.gallery?.banner);
                }
            } catch (error) {
                console.error("Failed to fetch Gallery:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchGalaryImages();
    }, []);
    return (
        <div className="container-fluid py-5">
            <div className="row align-items-start snapshot-row justify-content-center">
                <div className="col-lg-5 col-md-12">
                    <div className="snapshot-left">
                        <div className="snapshot-mini-title">
                            <span className="snapshot-dot"></span>
                            <span>Moments That Last Forever</span>
                        </div>

                        <h2 className="snapshot-main-title">A Snapshot of Fun!</h2>
                    </div>
                </div>

                <div className="col-lg-6 col-md-12">
                    <div className="snapshot-right">
                        <p className="snapshot-desc">
                            Take a peek into the world where smiles shine brighter, rides spin
                            faster, and every moment is worth remembering. This is where
                            memories are made — one photo at a time.
                        </p>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-11">

                    <Masonry
                        breakpointCols={breakpointColumnsObj}
                        className="masonry-grid"
                        columnClassName="masonry-grid-column"
                    >
                        {galaryImages.slice(0, 9).map((img, index) => (
                            <div key={index} className="masonry-item image-anime">
                                <img src={img} alt={`Gallery Image ${index}`} />
                            </div>
                        ))}
                    </Masonry>

                </div>
            </div>
        </div>
    );
}